import { HttpContextToken } from '@angular/common/http';

export const ALLOW_REFRESH = new HttpContextToken<boolean>(() => true);
